import { useState, useEffect } from 'react';

export const GOLD = '#C6A87C';

export const fmt = (n) =>
  n || n === 0
    ? `$${Number(n).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
    : '$0.00';

export const num = (n) => Number(n || 0).toLocaleString();

export const Card = ({ children, className = '' }) => (
  <div className={`bg-white border border-gray-200 rounded-xl p-5 ${className}`}>{children}</div>
);

export const Stat = ({ label, value, accent, testid }) => (
  <div className="bg-white border border-gray-200 rounded-xl p-5" data-testid={testid}>
    <p className="text-xs uppercase tracking-wide text-gray-400">{label}</p>
    <p className="text-2xl font-bold mt-1" style={{ color: accent || '#111' }}>{value}</p>
  </div>
);

export const Field = ({ label, value, onChange, type = 'number', readOnly, testid, suffix }) => (
  <div>
    <label className="text-xs font-medium text-gray-500">{label}</label>
    <div className="relative">
      <input
        data-testid={testid}
        type={type}
        value={value}
        disabled={readOnly}
        onChange={(e) => onChange(type === 'number' ? parseFloat(e.target.value) || 0 : e.target.value)}
        className="w-full mt-1 px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-[#C6A87C] focus:outline-none disabled:bg-gray-100"
      />
      {suffix && <span className="absolute right-3 top-3 text-xs text-gray-400">{suffix}</span>}
    </div>
  </div>
);

export const Row = ({ label, value, bold, accent, testid }) => (
  <div className="flex items-center justify-between" data-testid={testid}>
    <span className={bold ? 'font-semibold text-gray-900' : 'text-gray-600'}>{label}</span>
    <span className={bold ? 'font-bold text-lg' : 'font-medium text-gray-900'} style={accent ? { color: accent } : {}}>{value}</span>
  </div>
);

export const EntryTable = ({ headers, rows, testid }) => (
  <div className="bg-white border border-gray-200 rounded-xl p-5">
    <table className="w-full text-sm">
      <thead><tr className="text-left text-gray-400 border-b border-gray-200">{headers.map(h => <th key={h} className="py-2">{h}</th>)}</tr></thead>
      <tbody data-testid={testid}>
        {rows.length === 0 && <tr><td colSpan={headers.length} className="py-4 text-gray-400">No entries yet.</td></tr>}
        {rows.map((r, i) => (
          <tr key={i} className="border-b border-gray-100">{r.map((c, j) => <td key={j} className="py-2">{c}</td>)}</tr>
        ))}
      </tbody>
    </table>
  </div>
);

export const useEntries = (api, url, jobId) => {
  const [data, setData] = useState({ entries: [], summary: {} });
  const reload = () => {
    if (!jobId) return;
    api.get(url).then(r => setData(r.data)).catch(() => {});
  };
  useEffect(reload, [api, url, jobId]);
  return [data, reload];
};
